import { useMemo } from 'react';

import { useQueryAssetTypes } from '@hooks/assets/useQueryAssetTypes';

import { IAssetSubtypeById } from '@interfaces/assets/asset';
import { TSelectOptionType } from '@components/common/Select/Select.types';

export const useQueryAssetSubTypesByType = (assetTypeId: string | null) => {
	const { assetTypesSubtypes, isLoadingAssetTypes } = useQueryAssetTypes({ isAssetTypesSubtypesWithIconUrl: false });

	const assetSubTypesByType: Array<IAssetSubtypeById & TSelectOptionType<string>> = useMemo(() =>
		assetTypesSubtypes
			?.find((type) => type.value === assetTypeId)?.subTypes
			?.map((subType) => ({
				...subType,
				value: subType.id,
				label: subType.assetSubTypeName,
				// eslint-disable-next-line react-hooks/exhaustive-deps
			})) || [], [assetTypeId, assetTypesSubtypes.length]);

	return {
		assetTypesSubtypes,
		assetSubTypesByType,
		isLoadingAssetSubTypesByType: isLoadingAssetTypes,
	};
};
